
import React from "react";
import { ElfNameGeneratorTheme } from "./ElfNameGeneratorTheme";
import { ElfName } from "./ElfNameGenerator";

interface NameHistoryProps {
  history: ElfName[];
  onSelect: (name: ElfName) => void;
  onClear: () => void;
}

export const NameHistory: React.FC<NameHistoryProps> = ({
  history,
  onSelect,
  onClear
}) => {
  const formatTime = (timestamp: number) => {
    return new Date(timestamp).toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };
  
  return (
    <div className={ElfNameGeneratorTheme.historyContainer}>
      <div className={ElfNameGeneratorTheme.historyHeader}>
        <h3 className={ElfNameGeneratorTheme.historyTitle}>Previously Generated Names</h3>
        <button 
          onClick={onClear}
          className={ElfNameGeneratorTheme.historyClearButton}
        >
          Clear History
        </button>
      </div>
      
      <div className={ElfNameGeneratorTheme.historyList}>
        {history.map((name) => (
          <div 
            key={name.id} 
            className={ElfNameGeneratorTheme.historyItem}
            onClick={() => onSelect(name)}
          >
            <span className={ElfNameGeneratorTheme.historyName}>
              {name.firstName} {name.lastName}
            </span>
            <span className={ElfNameGeneratorTheme.historyTimestamp}>
              {formatTime(name.timestamp)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
